'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTriple = exports.entityHasType = exports.isEntityCreatedDate = exports.isEntityCreated = exports.isEntity = undefined;

var _overEvery2 = require('lodash/overEvery');

var _overEvery3 = _interopRequireDefault(_overEvery2);

var _negate2 = require('lodash/negate');

var _negate3 = _interopRequireDefault(_negate2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isNumber2 = require('lodash/isNumber');

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _conforms2 = require('lodash/conforms');

var _conforms3 = _interopRequireDefault(_conforms2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isValidType = isValidType;
exports.isValidId = isValidId;
exports.getTripleError = getTripleError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function entityChecker(source) {
  return (0, _overEvery3.default)(_isPlainObject3.default, (0, _conforms3.default)(source));
}
function isValidType(type) {
  return (0, _isString3.default)(type) && type.length > 2 && type[0] === type[0].toUpperCase();
}
function isValidId(id) {
  return (0, _isString3.default)(id) && id.length > 2;
}
// Check to see if object has required fields to be an entity.
var entity = { type: isValidType };
var isEntity = exports.isEntity = entityChecker(entity);
var entityCreated = _extends({}, entity, { id: isValidId });
var isEntityCreated = exports.isEntityCreated = entityChecker(entityCreated);
var entityCreatedDate = _extends({}, entityCreated, { dateCreated: _isNumber3.default });
var isEntityCreatedDate = exports.isEntityCreatedDate = entityChecker(entityCreatedDate);

var entityHasType = exports.entityHasType = (0, _curry3.default)(function (typeId, item) {
  return isEntity(item) && typeId === item.type;
});
var errMsgs = {
  plainObj: 'Triple must be an object.',
  subEnt: 'Triple must include subject object.',
  predicate: 'Predicate must be a string.',
  objEnt: 'Triple must include object prop.'
};

function getTripleError(triple) {
  var checkObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var subject = triple.subject,
      predicate = triple.predicate,
      object = triple.object;

  if (!(0, _isPlainObject3.default)(triple)) return errMsgs.plainObj;
  if (!isEntityCreated(subject)) return errMsgs.subEnt;
  if (!(0, _isString3.default)(predicate)) return errMsgs.predicate;
  if (checkObj && !isEntityCreated(object)) return errMsgs.objEnt;
  return false;
}
var isTriple = exports.isTriple = (0, _negate3.default)(getTripleError);


//////////////////
// WEBPACK FOOTER
// ./~/redux-graph/lib/lang.js
// module id = 634
// module chunks = 0